var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlatform(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 62,
    viewBox: "0 0 116 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.5932 47.9624H69.7014C69.0827 47.9624 68.5328 47.4078 68.5328 46.784V34.7919C68.5328 34.1681 69.0827 33.6135 69.7014 33.6135H81.5932C82.2119 33.6135 82.7618 34.1681 82.7618 34.7919V46.784C82.7618 47.4772 82.2119 47.9624 81.5932 47.9624Z",
    stroke: "#0D5AD0",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2855 48.4479H86.0613C85.7864 48.4479 85.5801 48.2399 85.5801 47.9626V42.6945C85.5801 42.4172 85.7864 42.2092 86.0613 42.2092H91.2855C91.5604 42.2092 91.7666 42.4172 91.7666 42.6945V47.8933C91.7666 48.1706 91.5604 48.4479 91.2855 48.4479Z",
    stroke: "#0D5AD0",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100.29 48.4479H95.0659C94.7909 48.4479 94.5847 48.2399 94.5847 47.9626V42.6945C94.5847 42.4172 94.7909 42.2092 95.0659 42.2092H100.29C100.565 42.2092 100.771 42.4172 100.771 42.6945V47.8933C100.771 48.1706 100.565 48.4479 100.29 48.4479Z",
    stroke: "#0D5AD0",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M111.976 61.4102H58.2219C56.5034 61.4102 55.0599 59.9545 55.0599 58.2216C55.0599 58.0136 55.2662 57.8057 55.4724 57.8057H114.725C114.931 57.8057 115.138 58.0136 115.138 58.2216C115.138 59.9545 113.763 61.4102 111.976 61.4102Z",
    stroke: "#0D5AD0",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3294 59.7466H81.868C80.7682 59.7466 79.9433 58.8454 79.9433 57.8057H90.3229C90.2541 58.8454 89.4293 59.7466 88.3294 59.7466Z",
    stroke: "#0D5AD0",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M110.051 57.8058H60.1466C58.8406 57.8058 57.8095 56.766 57.8095 55.4489V26.1967C57.8095 24.8796 58.8406 23.8398 60.1466 23.8398H110.051C111.357 23.8398 112.388 24.8796 112.388 26.1967V55.4489C112.388 56.766 111.357 57.8058 110.051 57.8058Z",
    stroke: "#0D5AD0",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M109.913 26.4739H60.2153V54.825H109.913V26.4739Z",
    stroke: "#0D5AD0",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6918 49.0717H42.7558H26.9459H5.36189C2.81856 49.0717 0.825134 46.9922 0.825134 44.4967V5.67852C0.825134 3.11374 2.8873 1.10352 5.36189 1.10352H64.3398C66.8831 1.10352 68.8765 3.18306 68.8765 5.67852V17.116",
    stroke: "#0D5AD0",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6917 39.2978H5.2243V7.61936C5.2243 6.51027 6.11791 5.60913 7.21773 5.60913H62.5525C63.6523 5.60913 64.5459 6.51027 64.5459 7.61936V17.1853",
    stroke: "#0D5AD0",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8507 45.1897C35.648 45.1897 36.2943 44.538 36.2943 43.734C36.2943 42.9301 35.648 42.2783 34.8507 42.2783C34.0535 42.2783 33.4072 42.9301 33.4072 43.734C33.4072 44.538 34.0535 45.1897 34.8507 45.1897Z",
    stroke: "#0D5AD0",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9459 49.0715L24.8837 56.5579H34.8509",
    stroke: "#0D5AD0",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7558 49.0715L44.8867 56.5579H34.8508",
    stroke: "#0D5AD0",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9487 56.5581H22.7527V59.9547H46.9487V56.5581Z",
    stroke: "#0D5AD0",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7864 33.6135H100.565",
    stroke: "#0D5AD0",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7864 36.8025H94.31",
    stroke: "#0D5AD0",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5485 16.492L16.8414 11.1545",
    stroke: "#0D5AD0",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2292 26.6818L22.2716 18.5715",
    stroke: "#0D5AD0",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlatform);
export default __webpack_public_path__ + "static/media/platform.e2e796ba.svg";
export { ForwardRef as ReactComponent };